import { useState } from "react";
import { toast } from "sonner";
import { RefreshCw, Repeat, Volume2, VolumeX } from "lucide-react";
import { isMuted, setMuted } from "@/lib/sound";
import { useAuth } from "@/context/AuthContext";
import { api, fmtAZN } from "@/lib/api";

export const ModeBar = ({ game, mode, onChange }) => {
  const { user, updateUser } = useAuth();
  const demo = mode === "demo";
  const [muted, setM] = useState(isMuted());
  const toggleMute = () => { setMuted(!muted); setM(!muted); };
  const reset = async () => {
    const { data } = await api.post("/wallet/demo-reset");
    updateUser(data);
    toast.success("Demo balans yeniləndi");
  };
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-white/10 bg-black/60 backdrop-blur-xl px-4 sm:px-6 py-3" data-testid="mode-bar">
      <div className="flex items-center gap-3">
        <h1 className="font-display font-bold text-lg sm:text-2xl">{game.name}</h1>
        <span className={`text-[10px] uppercase tracking-[0.2em] rounded-full px-3 py-1 ${demo ? "bg-sky-500/20 text-sky-300" : "bg-[#D4AF37]/20 text-[#FFD700]"}`} data-testid="mode-badge">
          {demo ? "Demo" : "Real"}
        </span>
      </div>
      <div className="flex items-center gap-3">
        <div className="text-right">
          <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">{demo ? "Demo balans" : "Real balans"}</p>
          <p className="font-display font-bold" data-testid="mode-balance">{fmtAZN(demo ? user?.demo_balance : user?.balance)}</p>
        </div>
        {demo && <button onClick={reset} className="btn-ghost rounded-full p-2.5" data-testid="demo-reset-btn" aria-label="Demo balansı yenilə"><RefreshCw size={16} /></button>}
        <button onClick={toggleMute} className="btn-ghost rounded-full p-2.5" data-testid="sound-toggle-btn" aria-label="Səs">{muted ? <VolumeX size={16} /> : <Volume2 size={16} />}</button>
        <button onClick={onChange} className="btn-ghost rounded-full px-4 py-2 text-sm flex items-center gap-2" data-testid="change-mode-btn"><Repeat size={14} /> Rejim</button>
      </div>
    </div>
  );
};
